import React, { Fragment, useContext, useEffect, useState } from 'react';
import ErrorBoundary from '../ErrorBoundary';
import { connect } from 'react-redux';
import { Badge, Button, Dropdown, Modal, Table } from 'react-bootstrap';
import Editor from '@jsx/components/RichTextEditor';
import { AdminActions } from '@adapters/redux/reducer/admin';
import PageLoader from '../Loader/PageLoader';
import Swal from 'sweetalert2';
import { ToastNotificationContext } from '@context/ToastNotificationContext';
import { fullBackendPath } from 'core/helpers';
import { ICON_MORE } from '@services/constant';
import moment from 'moment';

const Page = (props) => {
  const { notifySuccess, notifyError } = useContext(ToastNotificationContext);
  const { accounts, updateData, deleteData, updating } = props;

  const [showModal, setShowModal] = useState(false);

  const [modalType, setModalType] = useState('create');
  const [itemUpdate, setItemUpdate] = useState();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  useEffect(() => {
    if (!showModal) {
      setItemUpdate(null);
      setUsername('');
      setPassword('');
      setConfirmPassword('');
    }
  }, [showModal]);

  const onClickShowModalCreate = () => {
    setModalType('create');
    setUsername('');
    setPassword('');
    setConfirmPassword('');
    setShowModal(true);
  };

  const onClickShowModalEdit = (item) => {
    const { username } = item;

    setModalType('edit');
    setItemUpdate(item);
    setUsername('');
    setPassword('');
    setConfirmPassword('');
    setShowModal(true);
  };

  const onClickDelete = (item) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      confirmButtonColor: 'red',
      position: 'top',
      customClass: 'margin-top-20',
      reverseButtons: true,
    }).then(({ value }) => {
      if (value) {
        deleteData(
          item.id,
          `destination/${item.id}`,
          'accounts',
          (isError, error) => {
            if (isError) {
              notifyError(error);
            } else {
              notifySuccess('Delete successfully');
            }
          }
        );
      }
    });
  };

  const onSubmit = () => {
    const method = modalType === 'create' ? 'post' : 'put';
    const url =
      modalType === 'create' ? 'auth/register' : `auth/change-password`;

    if (username === '') {
      return notifyError('Please enter username');
    }

    if (password === '') {
      return notifyError('Please enter password');
    }

    if (password < 8) {
      return notifyError('Password at least 8 characters');
    }

    if (confirmPassword === '') {
      return notifyError('Please enter confirm password');
    }

    if (password !== confirmPassword) {
      return notifyError('Confirm password not same');
    }

    const params = {
      username,
      password,
      images: [],
    };

    updateData(method, url, params, 'accounts', (isError, error) => {
      if (isError) {
        notifyError(error);
      } else {
        setShowModal(false);
        notifySuccess(
          method === 'post' ? 'Create successfully' : 'Update successfully'
        );
      }
    });
  };

  return (
    <Fragment>
      <div className="text-right mb-3">
        <button onClick={onClickShowModalCreate} className="btn btn-success">
          Create
        </button>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">List Accounts</h4>
            </div>
            <div className="card-body position-relative">
              {updating && !showModal && <PageLoader />}
              <Table responsive>
                <thead>
                  <tr>
                    <th className="width80">
                      <strong>#</strong>
                    </th>
                    <th>
                      <strong>Username</strong>
                    </th>
                    <th>
                      <strong>Created at</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {accounts?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td className="cursor-pointer">{index + 1}</td>
                        <td className="cursor-pointer">{item.username}</td>
                        <td className="cursor-pointer">
                          {moment(item.createdAt).format('DD/MM/YYYY hh:mm')}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
      <Modal className="fade" enforceFocus={false} show={showModal} size="lg">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit();
          }}
        >
          <Modal.Header>
            <Modal.Title>
              {modalType === 'create' ? 'Create' : 'Edit'}
            </Modal.Title>
            <Button
              variant=""
              className="btn-close"
              onClick={() => setShowModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            {updating && <PageLoader />}
            <div className="form-group">
              <label className="form-label">Username</label>
              <input
                className="form-control"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div className="form-group mt-3">
              <label className="form-label">Password</label>
              <input
                className="form-control"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <div className="form-group mt-3">
              <label className="form-label">Confirm Password</label>
              <input
                className="form-control"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger light" onClick={() => setShowModal(false)}>
              Close
            </Button>
            <Button variant="" type="submit" className="btn btn-primary">
              {modalType === 'create' ? 'Create' : 'Update'}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  accounts: state.admin.accounts,
  updating: state.admin.updating,
});

const mapDispatchToProps = (dispatch) => ({
  updateData: (method, url, params, field, callback) =>
    dispatch(AdminActions.updateData(method, url, params, field, callback)),
  deleteData: (id, url, field, callback) =>
    dispatch(AdminActions.deleteData(id, url, field, callback)),
});

const withErrorBoundary = (props) => (
  <ErrorBoundary>
    <Page {...props} />
  </ErrorBoundary>
);

export default connect(mapStateToProps, mapDispatchToProps)(withErrorBoundary);
